// import html2canvas from 'html2canvas-pro';
import { jsPDF } from 'jspdf';
// import { svg2pdf } from 'svg2pdf.js';
import autoTable from 'jspdf-autotable';
import { applyPlugin } from 'jspdf-autotable';

applyPlugin(jsPDF);

window.addEventListener('DOMContentLoaded', () => {
	init();
});

function init() {
	const dataSheetButton = document.getElementsByClassName('data-sheet-btn')[0];
	const priceListButton = document.getElementsByClassName('price-list-btn')[0];

	dataSheetButton?.addEventListener('click', () => {
		generateDataSheet();
	});

	priceListButton?.addEventListener('click', () => {
		generatePriceList();
	});
}

function addTextElement(d, text, x, y, fontSize, fontStyle, maxWidth = 180): number {
	d.setFontSize(fontSize);
	d.setFont('helvetica', fontStyle);
	const textLines = d.splitTextToSize(text, maxWidth);
	d.text(textLines, x, y);
	const textHeight = d.getTextDimensions(textLines).h;
	return y + textHeight;
}

function addMain(d, x, y, maintitle) {
	const title = document.getElementsByTagName('h2')[0].innerHTML;
	const body_text = document
		.getElementsByClassName('wp-block-gridible-grid-container')[0]
		.getElementsByTagName('p');

	const main_image = document.getElementsByTagName('figure')[0].children[0];
	d.setFont('helvetica', 'normal');

	// Title and Subtitle
	y = addTextElement(d, maintitle, x, y, 16, 'bold') + 2;
	y = addTextElement(d, title, x, y, 11, 'bold') + 4;

	// Image
	const aspect = d.getImageProperties(main_image).width / d.getImageProperties(main_image).height;
	const imagesize = 70;
	d.addImage(main_image, 'JPEG', 132, 20, imagesize * aspect, imagesize, 'main', 'MEDIUM');

	// Main content
	Array.from(body_text).forEach((item) => {
		y = addTextElement(d, item.textContent, x, y, 10, 'normal', 110) + 5;
	});

	return y;
}

async function generateDataSheet() {
	const doc = new jsPDF();

	let cursor_y = 28;
	let cursor_x = 10;

	const main_title = document.getElementsByTagName('h1')[0].innerHTML;
	cursor_y = addMain(doc, cursor_x, cursor_y, main_title);

	const boxes_1 = document.getElementsByClassName('wp-block-gridible-grid-container')[1];

	// Box set 1
	let boxnum = 0;
	let box_y = cursor_y;
	Array.from(boxes_1.children).forEach((box) => {
		let box_x = boxnum * 65 + cursor_x;
		doc.setFillColor('#EEEEEE');
		doc.roundedRect(box_x, 180, 60, 85, 4, 4, 'F');

		doc.setTextColor('#5192CD');
		addTextElement(
			doc,
			box.getElementsByTagName('h3')[0].textContent,
			box_x + 3,
			box_y + 22,
			14,
			'normal',
			90
		) + 5;

		Array.from(box.getElementsByTagName('p')).forEach((child) => {
			addTextElement(doc, child.textContent, box_x + 3, box_y + 30, 10, 'normal', 50) + 5;
		});

		boxnum++;
	});

	doc.setTextColor('#000000');

	doc.addPage();
	cursor_y = addTextElement(doc, 'Technical Specifications', cursor_x, 28, 11, 'bold');

	document.querySelectorAll('.wp-block-details').forEach((item) => {
		if (cursor_y > 220) {
			doc.addPage();
			cursor_y = 28;
		}

		const table = item.children[1].children[0];
		const tableData = [];
		let footnote = '';

		Array.from(table.rows || []).forEach((row) => {
			const rowData = Array.from(row.cells).map((cell) => cell.textContent.trim());
			if (rowData[0][0] == '*') {
				footnote = rowData[0];
			} else {
				tableData.push(rowData);
			}
		});

		doc.autoTable({
			startY: cursor_y + 2,
			theme: 'striped',
			margin: {
				left: cursor_x,
			},
			styles: { cellWidth: 95, cellPadding: 3 },
			headStyles: { fillColor: [251, 173, 50] },
			head: [[item.children[0].textContent, '']],
			body: tableData,
			didParseCell: function (data) {
				// Optional: You can format specific cells here if the HTML scraping gets messy
				// console.debug(data.cell);
			},
		});

		// Table footnote
		if (footnote != '') {
			cursor_y =
				addTextElement(
					doc,
					footnote,
					cursor_x,
					doc.lastAutoTable.finalY + 5,
					10,
					'normal'
				) + 10;
		} else {
			cursor_y = doc.lastAutoTable.finalY + 10;
		}
	});

	const imageUrl =
		window.location.origin +
		'/wp-content/themes/solarws/assets/images/solarwatersolutions-logo-horizontal.png';
	const logo = await getBase64ImageFromUrl(imageUrl);

	addHeader(doc, cursor_x, main_title + ' | DATA SHEET', logo);

	const pdfBlob = doc.output('blob');
	const blobUrl = URL.createObjectURL(pdfBlob);
	window.open(blobUrl, '_blank');

	// doc.save(main_title + ' - data sheet.pdf');
}

async function generatePriceList() {
	const doc_list = new jsPDF();

	let cursor_y = 125;
	let cursor_x = 10;

	const main_title = document.getElementsByTagName('h1')[0].innerHTML;
	const title = document.getElementsByTagName('h2')[0].innerHTML;
	const body_text = document
		.getElementsByClassName('wp-block-gridible-grid-container')[0]
		.getElementsByTagName('p');

	const main_image = document.getElementsByTagName('figure')[0].children[0];
	doc_list.setFont('helvetica', 'normal');

	// Image
	const aspect =
		doc_list.getImageProperties(main_image).width /
		doc_list.getImageProperties(main_image).height;
	const imagesize = 90;
	doc_list.addImage(main_image, 'JPEG', 60, 20, imagesize * aspect, imagesize, 'main', 'MEDIUM');

	// Title and Subtitle
	cursor_y = addTextElement(doc_list, main_title, cursor_x, cursor_y, 16, 'bold') + 2;
	cursor_y = addTextElement(doc_list, title, cursor_x, cursor_y, 11, 'bold') + 4;

	// Main content
	Array.from(body_text).forEach((item) => {
		cursor_y =
			addTextElement(doc_list, item.textContent, cursor_x, cursor_y, 10, 'normal', 180) + 5;
	});

	cursor_y += 3;

	// Features
	const bulletpoints = document.getElementsByClassName('wp-block-list')[0].children;
	cursor_y = addList(doc_list, cursor_x, cursor_y, bulletpoints);

	doc_list.addPage();
	cursor_y = 20;

	// Read price table headings
	const table_headings = document.getElementsByTagName('h3');

	document.querySelectorAll('.price-list').forEach((item, index) => {
		if (cursor_y > 220) {
			doc_list.addPage();
			cursor_y = 30;
		}

		cursor_y = addTextElement(
			doc_list,
			table_headings[index].textContent,
			cursor_x,
			cursor_y,
			12,
			'bold'
		);

		const table = item.children[0];
		const tableData = [];
		let footnote = '';

		Array.from(table.rows || []).forEach((row) => {
			const rowData = Array.from(row.cells).map((cell) => cell.textContent.trim());
			if (rowData[0][0] == '*') {
				footnote = rowData[0];
			} else {
				tableData.push(rowData);
			}
		});

		tableData.shift();

		doc_list.autoTable({
			startY: cursor_y + 2,
			theme: 'striped',
			margin: {
				left: cursor_x,
				right: 9,
			},
			styles: { cellPadding: 3 },
			columnStyles: {
				0: { cellWidth: 15 },
				1: { cellWidth: 90 },
				2: { cellWidth: 15 },
				3: { cellWidth: 20 },
				4: { cellWidth: 20 },
				5: { cellWidth: 30 },
			},
			headStyles: { fillColor: [251, 173, 50] },
			head: [['Nr', 'Item', 'QTY', 'Volume', 'Weight', 'EUR']],
			body: tableData,
			didParseCell: function (data) {
				// Optional: You can format specific cells here if the HTML scraping gets messy
				// console.debug(data.cell);
			},
			/*
			willDrawCell: function (data) {
				if (data.section === 'body') {
					const cell = data.cell;
					const text = cell.raw;
					cell.text = [];
					renderText(doc_list, cell, text);
				}
			}, */
		});

		// Table footnote
		if (footnote != '') {
			cursor_y =
				addTextElement(
					doc_list,
					footnote,
					cursor_x,
					doc_list.lastAutoTable.finalY + 5,
					10,
					'normal'
				) + 10;
		} else {
			cursor_y = doc_list.lastAutoTable.finalY + 10;
		}
	});

	const imageUrl =
		window.location.origin +
		'/wp-content/themes/solarws/assets/images/solarwatersolutions-logo-horizontal.png';
	const logo = await getBase64ImageFromUrl(imageUrl);

	addHeader(doc_list, cursor_x, main_title + ' | PRICE LIST', logo);

	// const pdfBlob = doc_list.output('blob');
	// const blobUrl = URL.createObjectURL(pdfBlob);
	// window.open(blobUrl, '_blank');
	doc_list.save(main_title + ' - price list.pdf');
}

// -- Add bulletpoint list
function addList(d, x, y, items) {
	Array.from(items).forEach((item, index) => {
		d.setFillColor('#5192CD');
		d.circle(x + 2, y - 1, 1, 'F');
		y = addTextElement(d, item.textContent, x + 6, y, 10, 'normal') + 4;
	});
	return y;
}

// --- ADD HEADERS AND FOOTERS TO ALL PAGES ---
function addHeader(d, x, title, logo) {
	// const logo = document.getElementsByTagName('svg')[0];

	const pageCount = d.internal.getNumberOfPages();
	for (let i = 1; i <= pageCount; i++) {
		d.setPage(i); // Go to each page

		// BG
		d.setFillColor('#EEEEEE');
		d.rect(0, 0, 220, 10, 'F');

		// Header Settings
		d.setFontSize(9);
		d.setFont('helvetica', 'bold');
		d.setTextColor('#1A1A1A'); // Gray color for subtlety

		// Top Left Header
		const header_text = title;
		d.text(header_text, x, 6); //

		// Top Right Header
		// d.text('SOLAR WATER SOLUTIONS', 198, 6, { align: 'right' }); //
		d.addImage(logo, 'PNG', 154, 2.5, 46, 5, 'logo', 'LARGE');

		// Footer Settings
		d.setFontSize(10);

		// Background
		d.setFillColor('#5192CD');
		d.rect(0, 285, 220, 15, 'F');

		// Bottom Left Footer
		d.setFont('helvetica', 'normal');
		d.setTextColor('#FFFFFF'); // A nice blue tint matching the theme
		d.text("Let's power your next water project.", x, 292); //

		// Bottom Right Footer
		d.setFont('helvetica', 'normal');
		d.setTextColor('#FFFFFF');
		d.text('hello@solarwatersolutions.fi | solarwatersolutions.com', 200, 292, {
			align: 'right',
		}); //

		// Optional: Page Numbers (Bottom Center)
		// doc.setFontSize(8);
		// doc.text(`Page ${i} of ${pageCount}`, 105, 290, { align: 'center' });
	}

	console.debug('done');
}

/*
const processText = (text: string) => {
	return text?.split(/(<\/?b>)/).filter((part) => part.trim() !== '');
};

const renderText = (dc: jsPDF, cell, text: string) => {
	const parts = processText(text);
	const { x, y, width } = cell;
	let cursorX = x;
	dc.setFont('helvetica', 'normal');

	if (parts) {
		parts.forEach((part) => {
			if (part === '<strong>') {
				dc.setFont('helvetica', 'bold');
			} else if (part === '</strong>') {
				dc.setFont('helvetica', 'normal');
			} else {
				const textWidth = dc.getTextWidth(part);
				dc.text(part, cursorX, y);
				cursorX += textWidth;
			}
		});
	} else {
	}
};
 */

function getBase64ImageFromUrl(url) {
	return new Promise((resolve, reject) => {
		const img = new Image();
		// Allow loading from different domains (CORS)
		img.setAttribute('crossOrigin', 'anonymous');

		img.onload = () => {
			const canvas = document.createElement('canvas');
			canvas.width = img.width;
			canvas.height = img.height;
			const ctx = canvas.getContext('2d');
			ctx.drawImage(img, 0, 0);

			const dataURL = canvas.toDataURL('image/png');
			resolve(dataURL);
		};

		img.onerror = (error) => reject(error);
		img.src = url;
	});
}
